import * as React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { connect } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { AnyAction } from "redux";
import styled from "styled-components";
import { licenses, stringIds, bundleIds } from "../../../assets";
import { BundleMap } from "../../../models";
import { RootState, userActions } from "../../../store";
import {
    getLocalizedString,
    LARGE_SCREEN_WIDTH_THRESHOLD,
    paths,
} from "../../../utils";
import {
    CommonHeader,
    StickyDismissFooter,
    DISMISS_FOOTER_HEIGHT,
    styledTitle,
} from "../../components";
import * as rootStyles from "../../styles";
import { bundleMapSelector } from "../../../store/selectors/commonSelectors";

export const openSourceAttributionIdPrefix = "OpenSourceAttribution";
const testIDPrefix = "OpenSourceAttributionScreen";
const metricPrefix = "OpenSourceAttributionPage";

type ViewProps = {};

type StateProps = {
    bundleMap: BundleMap;
};

type DispatchProps = {
    updateCurrentPath: (payload: string) => void;
};

type Props = DispatchProps & StateProps & RouteComponentProps<ViewProps>;

export class OpenSourceAttributionScreen extends React.Component<Props> {
    constructor(props: any) {
        super(props);
        this.state = {};
        this.props.updateCurrentPath(window.location.pathname);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    componentDidUpdate(prevProps: Props) {}

    render() {
        return (
            <Container
                id={openSourceAttributionIdPrefix + "-Container"}
                fluid={true}
                className="rootContainer"
                style={rootStyles.containerStyles.rootViewContainer}
            >
                <CommonHeader
                    title={getLocalizedString(this.props.bundleMap, {
                        bundleId: bundleIds.SETTINGS_STRINGS,
                        stringId: stringIds.Settings.openSourceAttribution,
                    })}
                    id={`${testIDPrefix}_Header`}
                    hideArtistImgDropdown={true}
                    hideDatePicker={true}
                />
                <ContentRow
                    id={openSourceAttributionIdPrefix + "-Content"}
                >
                    <Col>
                        <span
                            style={{
                                ...rootStyles.textStyles.primary,
                                whiteSpace: "pre-wrap",
                                wordBreak: "break-word",
                            }}
                        >
                            {licenses}
                        </span>
                    </Col>
                </ContentRow>
                <StickyDismissFooter
                    title={getLocalizedString(this.props.bundleMap, {
                        bundleId: bundleIds.GENERIC_STRINGS,
                        stringId: stringIds.Generic.dismiss,
                    })}
                    onClick={() => this.props.history.goBack()}
                    id={`${testIDPrefix}_DismissButton`}
                />
            </Container>
        );
    }
}

const ContentRow = styled(Row)`
    margin-bottom: ${rootStyles.spacers.medium}px;
    @media (max-width: ${LARGE_SCREEN_WIDTH_THRESHOLD}px) {
        margin-bottom: ${DISMISS_FOOTER_HEIGHT + rootStyles.spacers.medium}px;
    }
`;

function mapStateToProps(state: RootState): StateProps {
    return bundleMapSelector(state);
}

function mapDispatchToProps(dispatch: React.Dispatch<AnyAction>) {
    return {
        updateCurrentPath: (payload: string) =>
            dispatch(userActions.updateCurrentPath(payload)),
    };
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(OpenSourceAttributionScreen)
);
